var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-2" },
    [
      _c("div", { staticClass: "table-responsive" }, [
        _c("table", [
          _c("thead", [
            _c("tr", [
              _c("th", [
                _c(
                  "button",
                  {
                    staticClass: "btn-success",
                    on: { click: _vm.agregarFila }
                  },
                  [_c("i", { staticClass: "fa fa-plus" })]
                )
              ]),
              _vm._v(" "),
              _c("th", [_vm._v("# Secuencia")]),
              _vm._v(" "),
              _c("th", [_vm._v("Descripción")]),
              _vm._v(" "),
              _c("th", [_vm._v("Tipo")]),
              _vm._v(" "),
              _c("th", [_vm._v("# Actual")]),
              _vm._v(" "),
              _c("th", [_vm._v("Acciones")])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.modelValue, function(puntoEmision, index) {
                return _c(
                  "tr",
                  {
                    key: index,
                    class: {
                      "tr--canceled": puntoEmision.estado === "I",
                      "tr--authorized": puntoEmision.estado === "A"
                    }
                  },
                  [
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "btn-info btn--text",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.editarFila(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-edit" })]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              readonly: "",
                              id: puntoEmision + index,
                              placeholder: "###"
                            },
                            model: {
                              value: puntoEmision.numero_secuencia,
                              callback: function($$v) {
                                _vm.$set(puntoEmision, "numero_secuencia", $$v)
                              },
                              expression: "puntoEmision.numero_secuencia"
                            }
                          },
                          [
                            _vm.errores.hasOwnProperty(
                              "puntosEmision." + index + ".numero_secuencia"
                            )
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.errores[
                                            "puntosEmision." +
                                              index +
                                              ".numero_secuencia"
                                          ][0]
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm.errores.hasOwnProperty(
                                  "puntosEmision." + index + ".numero_inicial"
                                )
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _vm._v(
                                      "\n                * " +
                                        _vm._s(
                                          _vm.errores[
                                            "puntosEmision." +
                                              index +
                                              ".numero_inicial"
                                          ][0]
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm.errores.hasOwnProperty(
                                  "puntosEmision." + index + ".numero_final"
                                )
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _vm._v(
                                      "\n                * " +
                                        _vm._s(
                                          _vm.errores[
                                            "puntosEmision." +
                                              index +
                                              ".numero_final"
                                          ][0]
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm.errores.hasOwnProperty(
                                  "puntosEmision." +
                                    index +
                                    ".numero_autorizacion"
                                )
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _vm._v(
                                      "\n                * " +
                                        _vm._s(
                                          _vm.errores[
                                            "puntosEmision." +
                                              index +
                                              ".numero_autorizacion"
                                          ][0]
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm.errores.hasOwnProperty(
                                  "puntosEmision." +
                                    index +
                                    ".fecha_autorizacion"
                                )
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _vm._v(
                                      "\n                * " +
                                        _vm._s(
                                          _vm.errores[
                                            "puntosEmision." +
                                              index +
                                              ".fecha_autorizacion"
                                          ][0]
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              id: "descripcion" + index,
                              placeholder: "Nombre del punto",
                              readonly: ""
                            },
                            model: {
                              value: puntoEmision.descripcion,
                              callback: function($$v) {
                                _vm.$set(puntoEmision, "descripcion", $$v)
                              },
                              expression: "puntoEmision.descripcion"
                            }
                          },
                          [
                            _vm.errores.hasOwnProperty(
                              "puntosEmision." + index + ".descripcion"
                            )
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.errores[
                                            "puntosEmision." +
                                              index +
                                              ".descripcion"
                                          ][0]
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(puntoEmision.tipo))]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              id: "descripcion" + index,
                              placeholder: "Nombre del punto",
                              readonly: ""
                            },
                            model: {
                              value: puntoEmision.numero_actual,
                              callback: function($$v) {
                                _vm.$set(puntoEmision, "numero_actual", $$v)
                              },
                              expression: "puntoEmision.numero_actual"
                            }
                          },
                          [
                            _vm.errores.hasOwnProperty(
                              "puntosEmision." + index + ".numero_actual"
                            )
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.errores[
                                            "puntosEmision." +
                                              index +
                                              ".numero_actual"
                                          ][0]
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: puntoEmision.estado === "A",
                              expression: "puntoEmision.estado === 'A'"
                            }
                          ],
                          staticClass: "btn-danger btn--text",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.eliminarFila(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-trash-o" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: puntoEmision.estado === "I",
                              expression: "puntoEmision.estado === 'I'"
                            }
                          ],
                          staticClass: "btn-success btn--text",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.eliminarFila(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-power-off" })]
                      )
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.modelValue.length === 0,
                      expression: "modelValue.length === 0"
                    }
                  ]
                },
                [_vm._m(0)]
              )
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            scrollable: "",
            name: "puntoEmision",
            height: "auto",
            width: "60%"
          }
        },
        [
          _c("punto-emision", {
            on: {
              input: _vm.inputPuntoEmision,
              cerrar: _vm.cerrarPuntoEmision
            },
            model: {
              value: _vm.selectedPuntoEmision,
              callback: function($$v) {
                _vm.selectedPuntoEmision = $$v
              },
              expression: "selectedPuntoEmision"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "5" } }, [
      _c("strong", [_vm._v("Agregue una fila.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fdc62b98", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdc62b98","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/localidades/TablaPuntoEmision.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-fdc62b98","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/localidades/TablaPuntoEmision.vue
// module chunks = 0